import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  indexOf1xbs558u7wr52 as indexOf,
  trim11nh7r46at6sx as trim,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  substringiqarkczpya5m as substring,
  substring3saq8ornu0luv as substring_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isCharSequence1ju9jr1w86plq as isCharSequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/http/Http.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  fromInt2ii0rejb1w62w as fromInt,
  subtract2orl8z9upxd9l as subtract,
  add2suhfggl4zvkk as add,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../okio-parent-okio/okio/Buffer.mjs';
import { Companion_instance35rvxj4aba79n as Companion_instance } from '../../../../../okio-parent-okio/okio/Options.mjs';
import { Companion_getInstance28gds36m4006o as Companion_getInstance } from '../../../../../okio-parent-okio/okio/ByteString.mjs';
import { DefaultApolloException8w3ielfxng0h as DefaultApolloException } from '../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { bufferbiiev5vr4b6f as buffer } from '../../../../../okio-parent-okio/okio/Okio.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function readHeaders($this, source) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var headers = ArrayList().u2();
  $l$loop: while (true) {
    var line = source.p3y();
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(line) === 0)
      break $l$loop;
    var index = indexOf(line, _Char___init__impl__6a9atx(58));
    // Inline function 'kotlin.check' call
    if (!!(index === -1)) {
      var message = 'Unexpected header: ' + line;
      throw IllegalStateException().o(toString(message));
    }
    // Inline function 'kotlin.text.trim' call
    var this_0 = substring(line, 0, index);
    var tmp = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
    // Inline function 'kotlin.text.trim' call
    var this_1 = substring_0(line, index + 1 | 0);
    var tmp$ret$5 = toString(trim(isCharSequence(this_1) ? this_1 : THROW_CCE()));
    // Inline function 'kotlin.collections.plusAssign' call
    var element = new (HttpHeader())(tmp, tmp$ret$5);
    headers.n2(element);
  }
  return headers;
}
var PartSourceClass;
function PartSource() {
  if (PartSourceClass === VOID) {
    class $ {
      constructor($outer) {
        this.h66_1 = $outer;
      }
      q6() {
        if (equals(this.h66_1.p66_1, this)) {
          this.h66_1.p66_1 = null;
        }
      }
      c3z(sink, byteCount) {
        // Inline function 'kotlin.require' call
        if (!(byteCount >= 0n)) {
          var message = 'byteCount < 0: ' + byteCount.toString();
          throw IllegalArgumentException().s2(toString(message));
        }
        // Inline function 'kotlin.check' call
        if (!equals(this.h66_1.p66_1, this)) {
          var message_0 = 'closed';
          throw IllegalStateException().o(toString(message_0));
        }
        var limit = currentPartBytesRemaining(this.h66_1, byteCount);
        return limit === 0n ? -1n : this.h66_1.i66_1.c3z(sink, limit);
      }
    }
    initMetadataForClass($, 'PartSource');
    PartSourceClass = $;
  }
  return PartSourceClass;
}
function currentPartBytesRemaining($this, maxResult) {
  $this.i66_1.a3y(fromInt($this.l66_1.v2()));
  var delimiterIndex = $this.i66_1.y3x().d3z($this.l66_1);
  var tmp;
  if (delimiterIndex === -1n) {
    var tmp0 = $this.i66_1.y3x().i3v_1;
    // Inline function 'kotlin.Long.minus' call
    var other = $this.l66_1.v2();
    // Inline function 'kotlin.Long.plus' call
    var this_0 = subtract(tmp0, fromInt(other));
    // Inline function 'kotlin.comparisons.minOf' call
    var b = add(this_0, fromInt(1));
    tmp = maxResult <= b ? maxResult : b;
  } else {
    // Inline function 'kotlin.comparisons.minOf' call
    tmp = maxResult <= delimiterIndex ? maxResult : delimiterIndex;
  }
  return tmp;
}
var PartClass;
function Part() {
  if (PartClass === VOID) {
    class $ {
      constructor(headers, body) {
        this.r66_1 = headers;
        this.s66_1 = body;
      }
      q6() {
        this.s66_1.q6();
      }
    }
    initMetadataForClass($, 'Part');
    PartClass = $;
  }
  return PartClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance_0;
function Companion_getInstance_0() {
  return Companion_instance_0;
}
var MultipartReaderClass;
function MultipartReader() {
  if (MultipartReaderClass === VOID) {
    class $ {
      constructor(source, boundary) {
        this.i66_1 = source;
        this.j66_1 = boundary;
        this.k66_1 = (new (Buffer())()).y3y('--').y3y(this.j66_1).k3y();
        this.l66_1 = (new (Buffer())()).y3y('\r\n--').y3y(this.j66_1).k3y();
        this.m66_1 = 0;
        this.n66_1 = false;
        this.o66_1 = false;
        this.p66_1 = null;
        this.q66_1 = Companion_instance.p3v([Companion_getInstance().e3x('\r\n--' + this.j66_1 + '--'), Companion_getInstance().e3x('\r\n'), Companion_getInstance().e3x('--'), Companion_getInstance().e3x(' '), Companion_getInstance().e3x('\t')]);
      }
      t66() {
        // Inline function 'kotlin.check' call
        if (!!this.n66_1) {
          var message = 'closed';
          throw IllegalStateException().o(toString(message));
        }
        if (this.o66_1)
          return null;
        if (this.m66_1 === 0 && this.i66_1.h3z(0n, this.k66_1)) {
          this.i66_1.j3v(fromInt(this.k66_1.v2()));
        } else {
          $l$loop: while (true) {
            var toSkip = currentPartBytesRemaining(this, 8192n);
            if (toSkip === 0n)
              break $l$loop;
            this.i66_1.j3v(toSkip);
          }
          this.i66_1.j3v(fromInt(this.l66_1.v2()));
        }
        var whitespace = false;
        afterBoundaryLoop: while (true) {
          switch (this.i66_1.s3y(this.q66_1)) {
            case 0:
              if (this.m66_1 === 0)
                throw DefaultApolloException().x44('expected at least 1 part');
              this.o66_1 = true;
              return null;
            case 1:
              this.m66_1 = this.m66_1 + 1 | 0;
              break afterBoundaryLoop;
            case 2:
              if (whitespace)
                throw DefaultApolloException().x44('unexpected characters after boundary');
              if (this.m66_1 === 0)
                throw DefaultApolloException().x44('expected at least 1 part');
              this.o66_1 = true;
              return null;
            case 3:
            case 4:
              whitespace = true;
              continue afterBoundaryLoop;
            case -1:
              if (this.i66_1.z3x()) {
                throw DefaultApolloException().x44('premature end of multipart body');
              } else {
                throw DefaultApolloException().x44('unexpected characters after boundary');
              }

          }
        }
        var headers = readHeaders(Companion_instance_0, this.i66_1);
        var partSource = new (PartSource())(this);
        this.p66_1 = partSource;
        return new (Part())(headers, buffer(partSource));
      }
      q6() {
        if (this.n66_1)
          return Unit_instance;
        this.n66_1 = true;
        this.p66_1 = null;
        this.i66_1.q6();
      }
    }
    initMetadataForClass($, 'MultipartReader');
    MultipartReaderClass = $;
  }
  return MultipartReaderClass;
}
//region block: init
Companion_instance_0 = new (Companion())();
//endregion
//region block: exports
export {
  MultipartReader as MultipartReader25md2ukkr9jti,
};
//endregion

//# sourceMappingURL=MultipartReader.mjs.map
